import { Component, Mixins } from "vue-property-decorator";
import store from "@/store";
import BroadcastersMixin from "@/mixins/http/SpecialInitiatives/BroadcastersMixin";

@Component
class SpecialInitiativesBroadcastersService extends Mixins(BroadcastersMixin) {
  created() {
    this.$store = store;
  }

  getBroadcasters() {
    return this.index();
  }
}

export default new SpecialInitiativesBroadcastersService();
